import { InjectionToken } from '@angular/core';
import { AppSettings } from '@models/generic';

/**
 * Injection token for application settings
 * Settings are provided via environment configuration in main.ts
 */
export const APP_SETTINGS = new InjectionToken<AppSettings>('app.config');
